module.exports = __webpack_public_path__ + "static/img/puting_3.28a3a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/puting_3.png
// module id = 179O
// module chunks = 1